<template lang='pug'>
#tabela-visualizar-processamento
        .tabela-visualizar-processamento__titulo
            h3 Listagem de territórios
            el-checkbox(
                v-model='buscarTerritoriosComRestricao',
                @change='buscarTerritorios'
            ) Mostrar apenas territórios com restrição

        el-card(:body-style='{ padding: "0px" }')
                el-table(
                    :data='territorios',
                    v-loading='carregandoTabela'
                    stripe
                    @selection-change='alterarTerritoriosSelecionados'
                )
                        //- el-table-column(prop='car', label='Car')
                        el-table-column(prop='territorioNome', label='Território')
                        el-table-column(prop='pessoaNome', label='Pessoa')
                        el-table-column(prop='cpfCnpj', label='Documento')
                        el-table-column(label='Análise socioambiental')
                            template(slot-scope='scope')
                                span(v-if='scope.row.totalRestricoes === 0')
                                    i.flow.flow-verified.verde.mr-2
                                    span.verde Conforme
                                el-tooltip(placement='top', :content="scope.row.totalRestricoes === 1 ?  '1 restrição' : `${scope.row.totalRestricoes} restrições`")
                                    span(v-if='scope.row.totalRestricoes > 0')
                                        i.flow.flow-warning-sign.vermelho.mr-2
                                        span.vermelho Inconforme
                        el-table-column(
                            prop='volumeInformado',
                            label='Volume estimado (t)'
                        )

                        el-table-column(
                            label='Ações',
                            align='center'
                        )
                            .template(slot-scope='scope')
                                el-dropdown.action-button
                                    i.mdi.mdi-dots-vertical
                                    el-dropdown-menu(slot='dropdown')
                                        el-dropdown-item(
                                            icon='el-icon-view',
                                            @click.native='visualizar(scope.row)'
                                        ) Visualizar

                                        el-dropdown-item(
                                            icon='el-icon-edit',
                                            v-if='podeRemoverTerritorio'
                                            @click.native='removerTerritorio(scope.row)'
                                        ) Remover
                        template(slot='empty')
                                el-empty(
                                    :description="$t('mensagens.comuns.semDados')"
                                )

                .tabela-visualizar-processamento__paginador
                        .tabela-visualizar-processamento__paginador__total
                            b Territórios: {{ paginacao.total }}
                            b Volume total: {{ volumeTotalTon }}

                        el-pagination(
                            small,
                            background,
                            layout='prev, pager, next',
                            :page-size='paginacao.itensPorPagina',
                            :current-page.sync='paginacao.pagina',
                            :total='paginacao.total',
                            @current-change='buscarTerritorios(paginacao.pagina - 1)'
                        )

        //- footer.mt-3
        //-     el-button(
        //-         type='danger',
        //-         icon='el-icon-delete',
        //-         @click.native='removerTerritorios'
        //-     ) Remover territorios
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';

export default {
    name: 'TabelaVisualizarProcessamentoContratoSubEmpresa',
    emits: ['visualizar', 'territorio-removido'],
    props: {
        numeroContrato: {
            required: true,
            type: String
        },
        podeRemoverTerritorio: {
            required: true,
            type: Boolean
        }
    },

    data() {
        return {
            territorios: [],
            volumeTotalTon: 0,
            paginacao: {
                itensPorPagina: 10,
                pagina: 0,
                total: 0,
                totalPaginas: 0
            },
            territoriosSelecionados: [],
            buscarTerritoriosComRestricao: false,
            carregandoTabela: false
        };
    },

    async mounted() {
        await this.buscarTerritorios(0);
    },

    methods: {
        async buscarTerritorios(pagina) {
            this.carregandoTabela = true;
            this.paginacao.pagina = pagina;
            try {
                await ContratoOriginacaoService.buscarTerritoriosVisualizarProcessamentoContratoSubEmpresa(
                {
                    contrato: this.numeroContrato,
                    pagina: this.paginacao.pagina,
                    tamanho: this.paginacao.itensPorPagina,
                    buscarTerritoriosComRestricao: this.buscarTerritoriosComRestricao
                })
                .then(({ data }) => {
                    this.territorios = data.itens;
                    this.volumeTotalTon = data.volumeTotalTon;
                    this.paginacao = { ...data.paginacao };
                    this.paginacao.pagina += 1;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                    this.$router.back();
                });
            } catch (error) {
            }
            this.carregandoTabela = false;
        },

        async removerTerritorio({idTerritorio}) {
            try {
                await ContratoOriginacaoService.removerTerritorioContratoSubEmpresa(
                this.numeroContrato,
                idTerritorio
            );
            this.buscarTerritorios();
            this.$emit('territorio-removido');
            this.$notify.success({
                message: 'Território removido do contrato de originação com sucesso!'
            });
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
        },

        async removerTerritorios() {
            for (const { idTerritorio } of this.territoriosSelecionados) {
                await this.removerTerritorio(idTerritorio);
            }
        },

        alterarTerritoriosSelecionados(linhas) {
            this.territoriosSelecionados = linhas;
        },

        visualizar(item) {
            this.$emit('visualizar', item);
        }
    }
};
</script>

<style lang='scss'>
.tabela-visualizar-processamento__paginador {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 4px 16px;
    .tabela-visualizar-processamento__paginador__total {
        display: flex;
        justify-content: space-between;
        gap: 24px;
    }
}

.tabela-visualizar-processamento__titulo {
    display: flex;
    justify-content: space-between;
    margin: 11px 0px;
    h3 {
        font-weight: bold;
    }
    .el-checkbox__label {
        font-weight: bold;
    }
}
#tabela-visualizar-processamento {
    .el-table {
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #FBFBFB;
            }
        }
        i.mdi.mdi-dots-vertical.el-dropdown-selfdefine {
            font-size: 25px;
        }
    }
}
</style>
